"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const parseIntSafe_1 = require("../../helpers/parseIntSafe");
function getTotalTimeString(sessionTime, totalTime) {
    if (!sessionTime || !totalTime || totalTime === 'NaN:NaN:NaN') {
        return '0000:00:00.00';
    }
    return totalTime;
}
function getSessionTimeString(sessionTime) {
    if (!sessionTime || sessionTime === 'NaN:NaN:NaN') {
        return '0000:00:00.00';
    }
    return sessionTime;
}
function getTimeValue(timeString) {
    const [hoursString, minutesString, secondsString] = timeString.split(':');
    return parseIntSafe_1.parseIntSafe(hoursString) * 3600 + parseIntSafe_1.parseIntSafe(minutesString) * 60 + parseIntSafe_1.parseIntSafe(secondsString);
}
function updateTimeSpentForScormCard(content, scormDataObject, state) {
    const currentTimeSpent = state.timeSpent || 0;
    const currentlyAvailableTimeSpent = 3 * content.content.duration - currentTimeSpent;
    if (currentlyAvailableTimeSpent <= 0) {
        return;
    }
    const totalTimeString = getTotalTimeString(scormDataObject.session_time, scormDataObject.total_time);
    const sessionTimeString = getSessionTimeString(scormDataObject.session_time);
    const totalTimeValue = getTimeValue(totalTimeString);
    const sessionTimeValue = getTimeValue(sessionTimeString);
    const scormDataTimeSpent = totalTimeValue !== 0 ? totalTimeValue : sessionTimeValue || currentTimeSpent;
    state.timeSpent += Math.min(scormDataTimeSpent, currentlyAvailableTimeSpent);
}
exports.updateTimeSpentForScormCard = updateTimeSpentForScormCard;
//# sourceMappingURL=updateTimeSpentForScormCard.js.map